import React, { useState, useEffect } from 'react';
//import Conexion from './../conexion/conexion';
import Header from '../elementos/basicos/Header';
import Cabecera from '../elementos/basicos/Cabecera';
import Card from '../elementos/basicos/Card';
import { Navigate } from 'react-router-dom';
import ContenedorCards from '../elementos/basicos/ContenedorCards';
import Row from 'react-bootstrap/Row';
import Footer from '../elementos/basicos/Footer';
import { StyleSheetManager } from 'styled-components';
import axios from 'axios';
import CondicionesCurso from '../elementos/basicos/CondicionesCurso';
import CargaCards from '../elementos/eventos/CargaCards';
import { fetchSubcategorias } from '../../peticiones_API/Peticiones_Subcategorias';



//Este objeto hará referencia a la página que listará de la categoría cursos ocupados las categorias principales de estos cursos
const ConvocatoriaSubcategorias = (categoria) => {
  // console.log("categoria ",categoria);
  //Gurdamos el estado de la lista las subcategorias de cursos
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorData, setErrorData] = useState(true);
  const urlPadre = window.location.pathname;

  //El use effect no enseñará el estado de la peticion de cursos de las subcategorias de ocupados
  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const response= await fetchSubcategorias(categoria.categoria.urlCat);
        setData(response);

        setLoading(false);
      } catch (error) {
        setErrorData(error.code)
        setLoading(false);

      }
    };

    obtenerDatos();
  }, [urlPadre]);

  //Devolvemos el jsx del html principal de las subcategorias de los cursos ocuypados
  return (
    <>
      <Header />
      <StyleSheetManager shouldForwardProp={() => true}>
        <Cabecera
          Titulo={categoria.categoria.categoria.toUpperCase() ? categoria.categoria.categoria.toUpperCase() : "CATEGORÍA DESCONOCIDA"}

          Texto_1="Cursos dirigidos a profesionales de los sectores de
          <b> SANIDAD y HOSTELERÍA Y TURISMO</b> , 
      también hay plazas disponibles para profesionales de cualquier otro sector 
      y para desempleados* y personas en ERTE.
      CURSOS 100% SUBVENCIONADOS POR EL SEPE."

          Texto_2="Descubre los cursos para cada sector"
          Estilo_Texto_2="true"

        ></Cabecera>
      </StyleSheetManager>

      <ContenedorCards>

        <Row className="justify-content-md-center">
          {loading ? (
            <CargaCards alineado="true" />
          ) : (
            errorData === "ERR_BAD_RESPONSE" ? (
              <Navigate to="/*" replace />
            ) : (
              <Card elementosLista={data} noReloj="true" />
            )
          )}
        </Row>

      </ContenedorCards>

      < CondicionesCurso />

      <Footer />



    </>
  );
}




export default ConvocatoriaSubcategorias;
